module.exports = __webpack_public_path__ + "f3964742b350dfe322c6a0e52c189e30.svg";